import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from '@backstage/core-plugin-api';
import { stringifyEntityRef } from '@backstage/catalog-model';
import { sendTechDocsViewEvent } from '@platt/backstage-plugin-techdocs-sample-analytics-react';
import { useCustomEntityAnalytics } from './useCustomEntityAnalytics';

export const useTechDocsAnalytics = () => {
  const { entity, loading, error } = useCustomEntityAnalytics();
  const analytics = useAnalytics();
  const location = useLocation();

  useEffect(() => {
    // /docsパスの場合のみイベント送信
    // エンティティがロード中、エラー、または存在しない場合は何もしない
    if (!location.pathname.includes('/docs') || loading || error || !entity) {
      return;
    }

    const entityRef = stringifyEntityRef(entity);
    const { kind, metadata } = entity;

    sendTechDocsViewEvent(
      analytics,
      entityRef,
      kind,
      metadata.name,
      metadata.namespace || 'default',
    );
  }, [location.pathname, entity, loading, error, analytics]);
};
